import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

export default function NotFound() {
  return (
    <div className="min-h-screen bg-white flex items-center justify-center px-4">
      <div className="max-w-2xl w-full text-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <h1 className="text-6xl md:text-8xl font-serif font-bold text-blue-900 mb-6">
            404
          </h1>
          <h2 className="text-2xl md:text-3xl font-serif text-blue-800 mb-4">
            Page Not Found
          </h2>
          <p className="text-gray-600 mb-8 text-lg">
            The page you're looking for doesn't exist or has been moved.
          </p>
          <Link
            to="/"
            className="inline-block px-8 py-4 bg-blue-900 text-white rounded-full font-semibold hover:bg-blue-800 transition-colors shadow-lg"
          >
            Return to Home
          </Link>
        </motion.div>
      </div>
    </div>
  );
} 